class LruCache {
    constructor(maxEntries = 20) {
        this.maxEntries = maxEntries;
        this.values = new Map();
    }
    get(key) {
        const hasKey = this.values.has(key);
        let entry = undefined;
        if (hasKey) {
            // peek the entry, re-insert for LRU strategy
            entry = this.values.get(key);
            this.values.delete(key);
            this.values.set(key, entry);
        }
        return entry;
    }
    put(key, value) {
        if (this.values.size >= this.maxEntries) {
            // least-recently used cache eviction strategy
            const keyToDelete = this.values.keys().next().value;
            this.values.delete(keyToDelete);
        }
        this.values.set(key, value);
    }
}

export { LruCache };
//# sourceMappingURL=lru-cache.js.map
